var alignment_rtlignore_default = {
  "alignLeft": "UpGyY",
  "textWrapNowrap": "ZaaB-",
  "alignRight": "pixCI",
  "alignCenter": "qNqX8",
  "sizeFullWidth": "PgsBA",
  "renderedInTable": "K4hQT",
  "sizeOriginal": "VBoMC",
  "sizeContent": "ED4K0",
  "sizeSmall": "u3h2-",
  "sizeSmallCenter": "hKmrr",
  "flex": "K7FAj",
  "LEFT": "sZUKR",
  "CENTER": "ER6Yq",
  "RIGHT": "ta-5P",
  "AUTO": "YFeZR",
  "JUSTIFY": "CN4-s"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
